import styled from "styled-components";

export const IconButtonDiv = styled.button`
  cursor: pointer;
  border: none;
  outline: none;
  box-shadow: none;
  background: none;
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;
`;
